import { AxiosResponse } from 'axios';
import api from './api';
import Template from '../models/Template/Template';
// TODO: Don't user model layer info
import { PaginationLinks, PaginationMeta, PaginationMetaLink } from '../models/Paginator';

type TemplateCreateRequest = Omit<Template, 'id'>;

interface InternalTemplate extends Omit<Template, 'template'> {
  template: string;
}

interface GetAllTemplatesResponse {
  data: InternalTemplate[]
  meta: PaginationMeta
  links: PaginationLinks
}

export interface GetAllTemplatesResult {
  data: Template[]
  meta: PaginationMeta
  links: PaginationLinks
}

export const getAllTemplates = async (page?: number, perPage?: number, type?: 'system-block' | 'my-block', searchText?: string): Promise<GetAllTemplatesResult> => {
  let url = 'v1/templates';

  const obj = new URLSearchParams();

  if (page != null) {
    obj.append('page', `${page}`);
  }

  if (perPage != null) {
    obj.append('per_page', `${perPage}`);
  }

  if (type != null) {
    obj.append('type', `${type}`);
  }

  if (searchText != null) {
    obj.append('search_term', `${searchText}`);
  }

  url += `?${obj.toString()}`;

  const result = await (await api.get<GetAllTemplatesResponse>(url)).data;
  return {
    data: result.data ? result.data.map((t) => ({ ...t, template: JSON.parse(t.template) })) : [],
    links: result.links,
    meta: result.meta,
  };
};

interface GetTemplatesByCategoryResponse {
  templateList: InternalTemplate[],
  templateListWithPagination: {
    data: InternalTemplate[],
    links: PaginationMetaLink[],
    current_page: number,
    total: number,
    to: number,
    from: number,
  }
}

export interface GetTemplatesByCategoryResult {
  data: Template[]
  currentPage: number
  links: PaginationMetaLink[]
  total: number
  to: number
  from: number
}

export const getTemplates = async (categoryId: string, page?: number, perPage?: number, type?: 'system-block' | 'my-block', searchText?: string): Promise<GetTemplatesByCategoryResult> => {
  let url = `v1/category/${categoryId}/templates`;

  const obj = new URLSearchParams();

  if (page != null) {
    obj.append('page', `${page}`);
  }

  if (perPage != null) {
    obj.append('per_page', `${perPage}`);
  }

  if (type != null) {
    obj.append('type', `${type}`);
  }

  if (searchText != null) {
    obj.append('search_term', `${searchText}`);
  }

  url += `?${obj.toString()}`;

  const result = (await api.get<GetTemplatesByCategoryResponse>(url)).data;
  const tList = result?.templateListWithPagination.data ? result?.templateListWithPagination.data.map((t) => ({ ...t, template: JSON.parse(t.template) })) : [];
  return {
    data: tList,
    links: result.templateListWithPagination.links,
    currentPage: result.templateListWithPagination.current_page,
    total: result.templateListWithPagination.total,
    to: result.templateListWithPagination.to,
    from: result.templateListWithPagination.from,
  };
};

export const getTemplate = async (id: string): Promise<AxiosResponse<{ data: Template }>> => api.get(`v1/templates/${id}`);

export const post = async (data: TemplateCreateRequest): Promise<AxiosResponse<string>> => api.post<string>('v1/templates/create', { ...data, template: JSON.stringify(data.template) });

export const put = async (data: Template) => api.post(`v1/templates/${data.id}/update`, { ...data, template: JSON.stringify(data.template) });

export const destroy = async (id: string) => api.post(`v1/templates/${id}/delete`, {});

export default {
  getAllTemplates,
  getTemplates,
  post,
  put,
  destroy,
};
